import type { FeatureCollection } from "@turf/helpers";
import type { Map as MapType } from "mapbox-gl";
import type { Dispatch, SetStateAction } from "react";
import { parseGeoData } from "senf-shared";
import { flyToPolygon } from "./flyToPolygon";

export function showMapbounds(
  statefulMap: MapType,
  mapbounds: FeatureCollection | string | null,
  flyToMapbounds: boolean,
  setPolygonMaskData: Dispatch<SetStateAction<null>>,
  // bounds?: {
  //   _ne: { lng: number; lat: number };
  //   _sw: { lng: number; lat: number };
  // } | null,
  initialAnimationDuration?: number,
) {
  setPolygonMaskData(parseGeoData(mapbounds));

  // if (bounds) {
  //   statefulMap.fitBounds([
  //     [bounds._ne.lng, bounds._ne.lat],
  //     [bounds._sw.lng, bounds._sw.lat],
  //   ]);
  //   return;
  // }

  if (mapbounds && flyToMapbounds) {
    flyToPolygon(statefulMap, parseGeoData(mapbounds), {
      duration: initialAnimationDuration || 0,
    });
  }
}
